
import React from 'react';

import { connect } from 'react-redux';

import { Link } from 'react-router-dom';
import {BASE_URL} from "../actions";

const ModelSingle = (props) => {

    if (props.loading === true) {
        return <div className="loader"></div>
    }

    return <div>
        <div className="row">
            <div className="col">
                <div className="row">
                    <div className="col">
                        <h1><Link to="/models" className="ml-2"><i
                            className="fa-light fa-arrow-left small"></i></Link> Modeller</h1>
                    </div>
                </div>
                <br />
                <table className="table contract-table">
                    <thead>
                    <tr>
                        <th>Modelluppgifter</th>
                        <th className="text-right">{props.contracts > 0 && <span className="badge badge-pill badge-warning">{props.contracts}st kontrakt skrivna {(new Date().getFullYear())}</span>}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td className="text-right">Porträtt</td><td><img src={props.profile} /></td>
                    </tr>
                    <tr>
                        <td className="text-right">Namn</td><td>{props.name} {props.last_name}</td>
                    </tr>
                    <tr>
                        <td className="text-right">Födelseår</td><td>{props.birth_year}</td>
                    </tr>
                    <tr>
                        <td className="text-right">Address</td><td>{props.address}, {props.postal_code} {props.city}</td>
                    </tr>
                    <tr>
                        <td className="text-right">Telefon</td><td>{props.phone}</td>
                    </tr>
                    <tr>
                        <td className="text-right">E-postadress</td><td>{props.email}</td>
                    </tr>
                    <tr>
                        <td className="text-right">Beskrivning</td><td>{props.description}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>

    </div>
}

export default connect(state => state.modelSingleState)(ModelSingle);
